import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { axiosInstance } from '../../Helpers/axiosInstance'
import styles from "../BaseList/BaseList.module.css";
import UnitListItem from '../MilUnitList/UnitListItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import PeopleList from './PeopleList';

export default function MillUnitsList({selectedUnit, setSelectedUnit, editing, setEditing, shouldUpdate}) {
    const [milUnits, setMilUnits] = useState([])
    const [corpuses, setCorpuses] = useState([])
    const [viewUnit, setViweUnit] = useState(null)
    const [search, setSearch] = useState("")

    useEffect(() => {   
           (async () => {
            const response = await axiosInstance.get('admin/milunits');
            if(response.data.status){
                setMilUnits(response.data.data)
            }

            const res = await axiosInstance.get('admin/corpuses')
            if(res.data.status){
                setCorpuses(res.data.data)
            }
        })()}, [])


    const viewUnitHandler = (unit) => {
      if(unit._id === viewUnit?._id){
        setViweUnit(null);
      }else{
        setViweUnit(unit);
      }
    };

  return (
    <div className='text-center'>
        <h2>Անձնակազմ</h2>
           <div className={styles["unit-list-container"]}>
          { !!milUnits?.filter(el => (el.unit_number.includes(search) || el.unit_close_number.includes(search)) && el.unit_corpus === "").length && <div>
              <h4>ՀԲԿ</h4>
              {
                 milUnits?.filter(el => (el.unit_number.includes(search) || el.unit_close_number.includes(search)) && el.unit_corpus === "").map((item, index) => (
                  <div className='relative'>
                    <UnitListItem
                        key={index}
                        item={item}
                        index={index}
                        onClick={() => setSelectedUnit(item)}
                      //   onClick={() => {fetchBases(item.unit_number);setUnitObj(item); setUnit(item.unit_number); setIsBaseListShown(true); if(selectedMode === "Մուտքագրում"){setCurrentBase(null)}}}
                    />
                    <FontAwesomeIcon icon={faEye} className='absolute top-[10px] right-[10px] cursor-pointer' onClick={() => viewUnitHandler(item)} />
                    {viewUnit?._id === item._id && <PeopleList unit={viewUnit} setSelectedUnit={setSelectedUnit} editing={editing} setEditing={setEditing} />}
                  </div>
                  )
                )
              }
            </div>
          }
          {
            corpuses?.map((corpus, index) => 
              milUnits.filter(el => (el.unit_number.includes(search) || el.unit_close_number.includes(search)) && el.unit_corpus === corpus._id).length ? (
              <div className={styles["unit-list-container"]} key={index}>
                <h4>{corpus.corpus_number} {corpus.corpus_name}</h4>
                {
                     milUnits.filter(el => (el.unit_number.includes(search) || el.unit_close_number.includes(search)) && el.unit_corpus === corpus._id).map((item, index) => (
                      <div className='relative' key={index}>
                        <UnitListItem
                            item={item}
                            index={index}
                            onClick={() => setSelectedUnit(item)}
                          //   onClick={() => {fetchBases(item.unit_number);setUnitObj(item); setUnit(item.unit_number); setIsBaseListShown(true); if(selectedMode === "Մուտքագրում"){setCurrentBase(null)}}}
                        />
                         <FontAwesomeIcon icon={faEye} className='absolute top-[10px] right-[10px] cursor-pointer' onClick={() => viewUnitHandler(item)} />
                         {viewUnit?._id === item._id && <PeopleList unit={viewUnit} setSelectedUnit={setSelectedUnit} editing={editing} setEditing={setEditing} shouldUpdate={shouldUpdate}/>}
                      </div>
                     )
                    )
                }
              </div>
            ) : ""
          )
          }
        </div>
    </div>
  )
}
